import Page from "webPage/Page";
import AccommodationModal from "modal/AccommodationModal";
import showBgElements from "util/showBgelements";

Page.register('page-template-search-results', () => {
    $('body').on('click', '.mphb-view-details-button', function(){
        let $modal_content = $(this).closest('.mphb-room-type').clone();
        let modal = new AccommodationModal($modal_content);

        let sliderSettings = $(this).closest('.mphb-flexslider').attr('data-flexslider-atts');

        modal.show();
        modal.$modal.find('.flex-control-nav').remove();
        modal.$modal.find('.flex-direction-nav').remove();
        modal.$modal.find('#mphb-flexslider-gallery-1').flexslider(sliderSettings);

        return false;
    });

    showBgElements();

    $(window).on('resize', showBgElements);
});
